// [auto-generated by inject-env.sh]
export const NODE_ENV = process.env["NODE_ENV"]
export const PUBLIC_URL = process.env["PUBLIC_URL"]
export const REACT_APP_MUSICME_API_URL = process.env["REACT_APP_MUSICME_API_URL"]
export const REACT_APP_EMBEDDED_PLAYER_URL = process.env["REACT_APP_EMBEDDED_PLAYER_URL"]
export const REACT_APP_EXPORT_PLAYLIST_URL = process.env["REACT_APP_EXPORT_PLAYLIST_URL"]
export const REACT_APP_SAMPLE_URL = process.env["REACT_APP_SAMPLE_URL"]// [/auto-generated]\n
